
export let trainingDate = {
    wld_fromDate: "",
    wld_toDate: "",
  };
  